import React, { useCallback, useMemo } from 'react'
import { connect, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'

import { setI18n } from './reducer'
import { getCookie } from '../utils/storage'
import { LOCALES } from '../utils/locales'

// eslint-disable-next-line max-len
const _InnerFormatText = ({ i18n, defaultValue, value }) =>
  (i18n || {})[value] || defaultValue || value

_InnerFormatText.propTypes = {
  i18n: PropTypes.object,
  value: PropTypes.string,
}

export const FormatText = connect(state => ({
  i18n: state.i18n.data,
}))(_InnerFormatText)

export const withI18n = Component =>
  connect(state => ({
    locale: state.i18n.locale,
    i18n: state.i18n.data,
    formatI18nText: (id, { defaultValue = '', values } = {}) => {
      let text = _InnerFormatText({ i18n: state.i18n.data, defaultValue, value: id })

      if (!values) return text

      Object.keys(values).forEach(key => {
        text = text.replace(`{${key}}`, values[key])
      })
      return text
    },
  }))(Component)

export const useI18n = () => {
  const locale = useSelector(state => state.i18n.locale)
  const i18n = useSelector(state => state.i18n.data)
  const formatI18nText = useCallback(
    (id, { defaultValue = '', values } = {}) => {
      let text = _InnerFormatText({ i18n, defaultValue, value: id })

      if (!values) return text

      Object.keys(values).forEach(key => {
        text = text.replace(`{${key}}`, values[key])
      })
      return text
    },
    [i18n]
  )

  return useMemo(() => ({ locale, formatI18nText }), [locale, formatI18nText])
}

export const addLocalePrefix = (...paths) =>
  paths.reduce((s, path) => s.concat([`/:locale${path}`]), [])

export const RouteWithRedirect = connect(state => ({
  locale: state.i18n.locale,
}))(({ component: Component, locale, dispatch, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      const { params, url } = props.match
      const prevLocale = locale || getCookie('lang') || 'en'
      const routeLocale = params.locale

      let _locale = routeLocale || prevLocale
      let redirectUrl

      // locale is exist.
      if (!LOCALES[_locale]) {
        _locale = prevLocale
        redirectUrl = `/${_locale}${url}`
      } else if (!routeLocale) {
        redirectUrl = `/${_locale}${props.location.pathname}`
      }

      dispatch(setI18n(_locale))
      if (redirectUrl) return <Redirect to={redirectUrl} />

      return <Component {...props} />
    }}
  />
))

export default {
  withI18n,
  FormatText,
  RouteWithRedirect,
}
